import Image from "next/image"
import { useLang } from "hooks/useLang"
import Link from "next/link"
import { FOOTER_LINKS } from "../Footer/Footer"
import VisaIcon from "components/icons/VisaIcon"
import MasterCardIcon from "components/icons/MasterCardIcon"
import StcPayIcon from "components/icons/StcPayIcon"
import ApplePayIcon from "components/icons/ApplePayIcon"
import AmericanExpressIcon from "components/icons/AmericanExpressIcon"
import MadaIcon from "components/icons/MadaIcon"
import AppSocialMedia from "components/atoms/AppSocialMedia"
import TabbyIcon from "components/icons/TabbyIcon"

export default function FooterMobile() {
    const { t, isAr } = useLang()

    return (
        <footer
            className={`relative flex h-[630px] flex-col overflow-hidden bg-white py-10 shadow-[0_0_9px_5px_rgba(0,0,0,0.05)] dark:bg-[#3A2B87] md:hidden`}>
            <div className="pointer-events-none absolute bottom-0 left-0 h-2/3 w-full scale-[2] opacity-80">
                <Image
                    src={"/svg/v2/footer_bg.webp"}
                    alt="footer_bg"
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    style={{ objectFit: "cover" }}
                    fill
                    priority
                />
            </div>

            <div className="relative flex h-full w-full flex-col items-center justify-center gap-10 p-8">
                <div className="flex flex-col items-center gap-2">
                    <Image
                        src="/svg/v2/footer-logo-v2.png"
                        alt="Footer-logo"
                        className="block h-auto w-auto dark:hidden"
                        style={{ objectFit: "contain" }}
                        height={110}
                        width={160}
                    />
                    <Image
                        src="/svg/v2/footer-logo-white-v2.png"
                        alt="Footer-logo"
                        className="hidden h-auto w-auto dark:block"
                        style={{ objectFit: "contain" }}
                        height={110}
                        width={160}
                    />
                    <span className="text-[10px] font-bold text-primary-theme-500 dark:text-white">
                        {t("made_in_saudi")}
                    </span>
                </div>

                <div className="grid grid-cols-2 gap-5">
                    {FOOTER_LINKS.map((item, index) => (
                        <div
                            key={index}
                            className={`text-center text-sm capitalize text-black transition-all dark:text-white`}>
                            <Link
                                href={item.linkTo}
                                className="cursor-pointer">
                                {t(item.title)}
                            </Link>
                        </div>
                    ))}
                </div>

                <AppSocialMedia />

                <div className="flex items-center justify-center gap-5">
                    <div className="flex items-center gap-2">
                        <VisaIcon
                            width={"100%"}
                            height={28}
                        />
                        <MasterCardIcon
                            width={"100%"}
                            height={28}
                        />
                        <StcPayIcon
                            width={"100%"}
                            height={28}
                        />
                        <ApplePayIcon
                            width={"100%"}
                            height={28}
                        />
                        <AmericanExpressIcon
                            width={"100%"}
                            height={28}
                        />
                        <MadaIcon
                            width={"100%"}
                            height={28}
                        />
                        <TabbyIcon width={"100%"} height={28} />
                    </div>
                </div>
                <hr className="w-full" />

                <div className={`flex w-full flex-col gap-5 capitalize`}>
                    <div className="flex justify-between">
                        <Link
                            href={"/support/privacy-policy"}
                            passHref
                            className="cursor-pointer text-xs text-black transition-all hover:text-gray-600 dark:text-white">
                            {t("privacy_policy_title")}
                        </Link>

                        <Link
                            href={"/support/terms-of-use"}
                            passHref
                            className="cursor-pointer text-xs text-black transition-all hover:text-gray-600 dark:text-white">
                            {t("USER_TAC_TITLE")}
                        </Link>
                    </div>

                    <div className="text-center text-xs text-black transition-all hover:text-gray-600 dark:text-white">
                        © {new Date().getFullYear()} {t("all_rights_reserved")}
                    </div>
                    <div className="flex flex-wrap justify-center gap-5">
                        {isAr ? (
                            <>
                                <span className="truncate text-[10px] text-black transition-all hover:text-gray-600 dark:text-white">
                                    شركة محور البداية لتقنية نظم المعلومات
                                </span>
                                <span className="truncate text-[10px] text-black transition-all hover:text-gray-600 dark:text-white">
                                    سجل تجاري رقم: 4030352391
                                </span>

                                <span className="truncate text-[10px] text-black transition-all hover:text-gray-600 dark:text-white">
                                    ترخيص رقم: 2306070105 الصادر من الهيئة
                                    العامة للترفيه
                                </span>
                            </>
                        ) : (
                            <>
                                <span className="truncate text-[10px] text-black transition-all hover:text-gray-600 dark:text-white">
                                    Start-Hub Information Systems Technology
                                    Company Ltd
                                </span>
                                <span className="truncate text-[10px] text-black transition-all hover:text-gray-600 dark:text-white">
                                    C.R: 4030352391
                                </span>
                                <span className="truncate text-[10px] text-black transition-all hover:text-gray-600 dark:text-white">
                                    License No: 2306070105 issued by the General
                                    Entertainment Authority
                                </span>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </footer>
    )
}
